import type { ReadConfig } from 'api-read-hook';

import { useApiRead } from 'api-read-hook';

export type BaseView = {
  '@id': string;
  '@type': 'CompanyTicketStats';
  numOpenInfoNeeded: number;
  numOpenWithResolution: number;
};

export function useReadItemTicketStats(id: string, options?: ReadConfig) {
  return useApiRead<BaseView>(`/companies/${id}/ticket-stats`, options);
}
